<template>
  <!-- <v-sheet color="rgba(0, 0, 0, .12)" > -->
  <div
    :id="id"
    class="inventory-item-pie-chart"
    :style="{ height: height + 'px' }"
  ></div>
  <!-- </v-sheet> -->
</template>
  
  <script>
import * as echarts from "echarts";
import { CommonHelper } from "../../../../helpers/common.helper";
import themeJson from '@/assets/echarts-themes/oceanic-balanced.json';

export default {
  name: "InventoryItemPieChart",
  props: {
    id: {
      type: String,
      default: "inventory-item-pie-chart",
    },
    value: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      colors: CommonHelper.generateGradientColors(
        "#0C5AD5",
        "#CBD5E1",
        this.value.length
      ),

      //   [
      //     "#0C5AD5",
      //     "#CBD5E1",
      //     "#94A3B8",
      //     "#64748B",
      //     "#1E293B",
      //     "#0F172A",
      //   ],
    };
  },
  watch: {
    value: {
      handler() {
        this.colors = CommonHelper.generateGradientColors(
          "#0C5AD5",
          "#CBD5E1",
          this.value.length
        );
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
  },

  methods: {
    renderChart() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      const chart = echarts.init(chartDom, themeJson.themeName);
      chart.setOption(this.getOptions());
    },
    getOptions() {
      return {
        // color: this.colors,
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
        },
        legend: {
          // just hide
          show: false,
          orient: "vertical",
          left: "left",

          textStyle: {
            fontSize: 14,
            fontFamily: "Roboto",
          },
        },
        series: [
          {
            name: "Categories",
            type: "pie",
            radius: "60%",
            center: ["50%", "50%"],
            data: this.value.map((item) => ({
              name: item.name,
              value: item.item_count,
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
                fontFamily: "Roboto",
              },
            },
            label: {
              fontFamily: "Roboto",
              fontSize: 14,
            },
          },
        ],
      };
    },
  },
};
</script>
  
  <style scoped>
.inventory-item-pie-chart {
  width: 100%;
  font-family: Roboto, sans-serif;
}
</style>
  